'use client';

import { useMemo } from 'react';

type Client = {
  redirectUris: string[];
  scopes: string[];
};

const useOAuth = (searchParams: URLSearchParams, client: Client) => {
  const responseType = useMemo(() => {
    if (!searchParams.has('response_type')) return 'code';
    return searchParams.get('response_type') ?? '';
  }, [searchParams]);

  const state = useMemo(() => {
    if (!searchParams.has('state')) return '';
    return searchParams.get('state') ?? '';
  }, [searchParams]);

  const redirectUri = useMemo(() => {
    if (!searchParams.has('redirect_uri')) return client.redirectUris[0];
    return searchParams.get('redirect_uri') ?? '';
  }, [searchParams, client.redirectUris]);

  const scope = useMemo(() => {
    if (!searchParams.has('scope')) return client.scopes.join(' ');
    return searchParams.get('scope') ?? '';
  }, [searchParams, client.scopes]);

  return { responseType, scope, state, redirectUri };
};

export default useOAuth;
